<script lang="ts">
	import { page } from '$app/state';
	import SidebarSection from './SidebarSection.svelte';
	import { getSharedSessions, sharedLoaded } from '$lib/shared-sessions-store.svelte';
	import { sharedViewerHref } from '$lib/shared-routing';

	const shared = getSharedSessions();
	const sidebarShared = $derived(shared.filter((s) => s.sidebarVisible !== false));

	// Highlight the active shared chat. The viewer route is /shared/<owner>/<id>.
	const activeShared = $derived.by(() => {
		const m = page.url.pathname.match(/^\/shared\/[^/]+\/([^/]+)/);
		return m ? decodeURIComponent(m[1]) : null;
	});

	function ownerLabel(s: { ownerName: string | null; ownerSub: string }): string {
		return s.ownerName?.trim() || s.ownerSub;
	}

	let open = $state(true);
</script>

<!-- Open WebUI's "Shared" folder block: the same chat rows as the user's own
     chats, with the owner's name in the time-ago slot. -->
{#if sharedLoaded() && sidebarShared.length > 0}
	<SidebarSection name="Shared with me" id="shared" bind:open class="mt-1.5">
		<div class="pt-1.5" role="list">
			{#each sidebarShared as s (s.ownerSub + '::' + s.sessionId)}
				{@const isActive = s.sessionId === activeShared}
				{@const href = sharedViewerHref(s.ownerSub, s.sessionId)}
				<div class="relative w-full" role="listitem">
					<a
						{href}
						aria-current={isActive ? 'page' : undefined}
						title={'shared by ' + ownerLabel(s)}
						class="flex w-full justify-between rounded-xl px-2 py-1.5 whitespace-nowrap transition {isActive
							? 'bg-black/[0.035] dark:bg-white/[0.045]'
							: 'hover:bg-gray-100 dark:hover:bg-gray-900'}"
					>
						<span dir="auto" class="h-5 min-w-0 flex-1 self-center truncate text-left">
							{s.title?.trim() || s.sessionId.slice(0, 8)}
						</span>
						<span
							class="max-w-[40%] shrink-0 self-center truncate pl-2 text-[0.625rem] text-gray-400 dark:text-gray-500"
							aria-hidden="true">{ownerLabel(s)}</span
						>
					</a>
				</div>
			{/each}
		</div>
	</SidebarSection>
{/if}
